import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
import Profile from "../pages/Profile";
import Login from "../pages/Login";
import Unauthorized from "../pages/Unauthorized";
import NotFound from "../pages/NotFound";
import { Role } from "../constants/Role";
import Categories from "../pages/AdminPage/ManageCategories";
import AboutUs from "pages/AboutUs";
import LearnCourse from "pages/LearnCourse/LearnCourse";
import ManageCourses from "../pages/AdminPage/ManageCourse";
import AdminDashboard from "../pages/AdminPage/AdminDashboard";
import HomePage from "pages/HomePage";
import HorizontalCourseCard from "components/HorizontalCourseCard";
import CourseDetail from "pages/CourseDetail";
import MyCourses from "pages/MyCourses";
import ManageLearnCourse from "pages/LearnCourse/ManageLearnCourse";
import CourseList from "pages/CourseList";
import ContactUs from "pages/ContactUs";
import PaymentSuccess from "../pages/PaymentSuccess";
import PaymentError from "../pages/PaymentError";
import Cart from "pages/Cart";
import Checkout from "pages/Checkout";
import { OrderManagement } from '../pages/AdminPage';
import FAQs from "pages/FAQs";
import OrderHistory from '../pages/OrderHistory';
import MentorCourses from "pages/MentorCourses";

const AppRoutes = () => (
  <Routes>
    {/* Public routes */}
    <Route path="/" element={<HomePage />} />
    <Route path="/login" element={<Login />} />
    <Route path="/unauthorized" element={<Unauthorized />} />
    <Route path="/about" element={<AboutUs />} />
    <Route path="/all-courses" element={<CourseList/>}/>
    <Route path="/contact-us" element={<ContactUs />} />
    <Route path="/payment/success" element={<PaymentSuccess />} />
    <Route path="/payment/error" element={<PaymentError />} />
    <Route path="/faqs" element={<FAQs />} />
    <Route path="/order-history" element={<OrderHistory />} />
    {/* Protected routes */}
    
    <Route
      path="/profile"
      element={
        <ProtectedRoute>
          <Profile />
        </ProtectedRoute>
      }
    />

<Route
      path="/my-courses"
      element={
        <ProtectedRoute roles={[Role.LEARNER]}>
          <MyCourses  />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin"
      element={
        <ProtectedRoute roles={[ Role.ADMIN_DEV, Role.ADMIN_BUSINESS, Role.STAFF_ACCOUNTING, Role.STAFF_COURSE_MANAGER]}>
          <AdminDashboard />
        </ProtectedRoute>
      }
    />
    <Route
      path="/manage/orders"
      element={
        <ProtectedRoute roles={[Role.ADMIN_DEV, Role.STAFF_ACCOUNTING]}>
          <OrderManagement />
        </ProtectedRoute>
      }
    />
    {/* Redirect /admin-panel to /admin for convenience */}
    <Route path="/admin-panel" element={<Navigate to="/admin" replace />} />

    <Route
      path="/manage/categories"
      element={
        <ProtectedRoute roles={[Role.ADMIN_DEV, Role.ADMIN_BUSINESS]}>
          <Categories />
        </ProtectedRoute>
      }
    />
    
    <Route
      path="/manage/courses"
      element={
        <ProtectedRoute roles={[Role.ADMIN_DEV, Role.ADMIN_BUSINESS, Role.STAFF_COURSE_MANAGER]}>
          <ManageCourses />
        </ProtectedRoute>
      }
    />
    <Route
      path="/mentor/courses"
      element={
        <ProtectedRoute roles={[Role.STAFF_COURSE_MENTOR]}>
          <MentorCourses />
        </ProtectedRoute>
      }
    />
    
    <Route
      path="/course-builder/:id"
      element={
        <ProtectedRoute roles={[Role.ADMIN_DEV, Role.ADMIN_BUSINESS, Role.STAFF_COURSE_MANAGER]}>
          <ManageLearnCourse />
        </ProtectedRoute>
      }
    />

    <Route
      path="/learner/my-courses/:courseSlug"
      element={
        <ProtectedRoute roles={[Role.LEARNER]}>
          <LearnCourse />
        </ProtectedRoute>
      }
    />

    <Route path="/courses/:courseSlug" element={<CourseDetail />} />
    <Route
      path="/cart"
      element={
        <ProtectedRoute roles={[Role.LEARNER,Role.ADMIN_DEV]}>
          <Cart />
        </ProtectedRoute>
      }
    />

<Route
      path="/cart/checkout"
      element={
        <ProtectedRoute roles={[Role.LEARNER,Role.ADMIN_DEV]}>
          <Checkout />
        </ProtectedRoute>
      }
    />

    <Route
      path="/learningzone/:courseSlug"
      element={
        <ProtectedRoute roles={[Role.STAFF_COURSE_MENTOR]}>
          <LearnCourse />
        </ProtectedRoute>
      }
    />

    {/* 404 route */}
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes;
